module.exports = __webpack_public_path__ + "media/images/flags/nl-e57661dbd0b3b59891e4e3e3f2e497d8.svg";